import { ChartName, ChartType } from '../types/data'

export const baseUrl = 'https://connect.fm-world.com/session-provider/v1/'
export const ssoBaseUrl = 'https://api.peperoni.ai/22sso-api/'

export const getChartData = (type: ChartType, name: ChartName, withAuthentication: boolean): string => {
    const prefix = withAuthentication ? 'charts' : 'free-charts'
    return `${baseUrl}${prefix}?type=${type}&name=${name}`
}

export const getUserData = (uuid: string) => {
    return `${ssoBaseUrl}users/${uuid}`
}
